// Event-specific hardcoded visit dates per ticket type
// Key: ticket_type_id (from database), Value: visit date in YYYY-MM-DD
// Format: ticket_type_id : 'YYYY-MM-DD', // Ticket Type Name
const event_visit_dates = {
    22 : '2026-08-29', // Escape
    23 : '2026-08-29', // Kidzania KL
    24 : '2026-09-05', // Kidzania SG
};

export default event_visit_dates;
